<template>
  <VDialog v-model="dialog" width="600px">
    <VCard>
      <VBtn
        absolute
        icon
        right
        style="right: 0"
        class="mt-0 pb-0"
        @click="close"
      >
        <VIcon>mdi-close</VIcon>
      </VBtn>

      <VCardTitle>{{ contractItem.productName }}</VCardTitle>
      <!--      <VCardSubtitle-->
      <!--        class="mt-0 pb-0"-->
      <!--        :style="{-->
      <!--          color: statusColor,-->
      <!--        }"-->
      <!--        >{{ $t(`contractOmtkStatus.${contractItem.state}`) }}-->
      <!--      </VCardSubtitle>-->
      <!--      TODO idk what is that-->
      <VCardText>
        <VList dense class="pt-0">
          <VListItem class="px-0 pt-0">
            <VListItemContent>
              <VListItemTitle class="mt-2"
                >{{ $t("typeProduct") }}:
                {{
                  contractItem.productCategory
                    ? contractItem.productCategory[`name_${$i18n.locale}`]
                    : ""
                }}
              </VListItemTitle>
              <VListItemTitle
                class="mt-2 mini-attribute-dotes"
                style="white-space: normal"
                v-if="contractItem.description"
                >{{ $t("attributes") }}:
                {{ contractItem.description }}
              </VListItemTitle>
              <VListItemTitle class="mt-2"
                >{{ $t("count") }}: {{ contractItem.count | numberParse }}
                {{ contractItem.unitTypeName }}
              </VListItemTitle>
            </VListItemContent>
          </VListItem>
          <div
            class="d-flex justify-space-between align-center"
            v-for="initiator in initiators"
            :key="initiator.id"
          >
            <VCardSubtitle class="mt-0 pb-0 pt-1 px-0">
              {{ initiator.initiator }}
            </VCardSubtitle>
            <div class="d-flex align-center">
              <VueIcon
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.ACCEPTED ||
                  initiator.statusType === INITIATOR_STATUS_TYPE.PART_ACCEPTED
                "
                class="mt-3 mr-3"
                icon="checkIcon"
                fill="#68B833"
              ></VueIcon>

              <VueIcon
                v-if="initiator.statusType === INITIATOR_STATUS_TYPE.REJECTED"
                class="ml-2 mr-3 mt-3"
                width="12px"
                icon="cancelIcon"
                fill="#ee6565"
              ></VueIcon>
              <svg
                width="18px"
                viewBox="0 0 26.349 26.35"
                v-if="
                  initiator.statusType === INITIATOR_STATUS_TYPE.WAITING &&
                  initiator.notificationSent
                "
                fill="#FDCC05"
              >
                <g>
                  <g>
                    <circle cx="13.792" cy="3.082" r="3.082" />
                    <circle cx="13.792" cy="24.501" r="1.849" />
                    <circle cx="6.219" cy="6.218" r="2.774" />
                    <circle cx="21.365" cy="21.363" r="1.541" />
                    <circle cx="3.082" cy="13.792" r="2.465" />
                    <circle cx="24.501" cy="13.791" r="1.232" />
                    <path
                      d="M4.694,19.84c-0.843,0.843-0.843,2.207,0,3.05c0.842,0.843,2.208,0.843,3.05,0c0.843-0.843,0.843-2.207,0-3.05
			C6.902,18.996,5.537,18.988,4.694,19.84z"
                    />
                    <circle cx="21.364" cy="6.218" r="0.924" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </VList>

        <div
          class="mt-3"
          v-if="isNotificationSent && !acceptedStatus && !rejectedStatus"
        >
          <div class="d-flex justify-space-between mb-3">
            <VBtn
              class="white--text"
              width="45%"
              color="green"
              @click="matched(getInitiatorId)"
              >{{ $t("matched") }}
            </VBtn>

            <VBtn
              class="white--text"
              width="45%"
              color="error"
              @click="openOzlDenyContractDialog(getInitiatorId)"
              >{{ $t("notCompatible") }}
            </VBtn>
          </div>
        </div>
      </VCardText>
    </VCard>
    <RejectContractDialog
      ref="rejectContractDialogRef"
      @updateTableData="updateTableData"
    ></RejectContractDialog>
  </VDialog>
</template>

<script>
import {
  INITIATOR_STATUS_TYPE,
  contractItemStatus,
} from "@/utils/constants.js";
import RejectContractDialog from "@/components/division/RejectContractDialog.vue";
import { trueSet } from "@/utils/pureFunctions.js";

const CONTRACT_ITEM = {
  state: null,
  productName: null,
  productGroupName: null,
  productCategory: null,
  description: null,
  count: null,
  unitTypeName: null,
  id: null,
};
export default {
  data() {
    return {
      dialog: false,
      contractItem: {
        ...CONTRACT_ITEM,
      },
      initiators: [],
    };
  },
  components: {
    RejectContractDialog,
  },
  computed: {
    INITIATOR_STATUS_TYPE() {
      return INITIATOR_STATUS_TYPE;
    },
    contractItemStatus() {
      return contractItemStatus;
    },
    statusColor() {
      switch (this.contractItem.state) {
        case contractItemStatus.CONTRACT_ITEM_ACCEPTED:
          return "#36C281";
        case contractItemStatus.CONTRACT_ITEM_REJECT:
          return "#ee6565";
        case contractItemStatus.CONTRACT_ITEM_PART_ACCEPTED:
          return "#FDCC05";
        case contractItemStatus.CONTRACT_ITEM_PARTITION_ACCEPTED:
          return "#FDCC05";
        case contractItemStatus.NEW:
          return "#01456A";
        default:
          return "#FDCC05";
      }
    },
    isNotificationSent() {
      let isOwner = this.initiators.find((item) =>
        trueSet(
          item.isOwner
          /**
           * @type Object
           * @property isOwner
           */
        )
      );
      return trueSet(isOwner ? isOwner.notificationSent : false);
    },
    acceptedStatus() {
      let isOwner = this.initiators.find((item) => trueSet(item.isOwner));
      return (
        isOwner !== undefined &&
        isOwner.statusType === this.INITIATOR_STATUS_TYPE.ACCEPTED
      );
    },
    getInitiatorId() {
      let initiatorId = this.initiators.find((item) => trueSet(item.isOwner));
      if (initiatorId !== undefined && initiatorId.notificationSent) {
        return initiatorId.id;
      } else return null;
    },
    rejectedStatus() {
      let isOwner = this.initiators.find((item) => trueSet(item.isOwner));
      return (
        isOwner !== undefined &&
        isOwner.statusType === this.INITIATOR_STATUS_TYPE.REJECTED
      );
    },
  },
  methods: {
    async matched(contractItemId) {
      this.showLoading();
      try {
        await this.$http.post("user-agreement/accept", contractItemId, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        this.setSuccess({ text: this.$t("successfullySaved") });
        await this.getInitiator();
        this.$emit("ozlDecided");
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    openOzlDenyContractDialog(contractItemId) {
      const { rejectContractDialogRef } = this.$refs;
      if (rejectContractDialogRef) {
        rejectContractDialogRef.open(contractItemId);
      }
    },
    updateTableData() {
      this.getInitiator();
      this.$emit("ozlDecided");
    },
    close() {
      this.dialog = false;
    },
    async getInitiator() {
      this.showLoading();
      try {
        let contractItemId = this.contractItem.id;
        const {
          data: { data },
        } = await this.$http.get("user-agreement/get-initsiators", {
          params: { contractItemId },
        });
        this.initiators = data.map((item) => {
          let notificationSent = trueSet(item.notificationSent);
          item.notificationSent = notificationSent;
          return item;
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    open({
      id,
      state,
      productName,
      initiatorCount,
      productGroupName,
      productCategory,
      description,
      count,
      unitTypeName,
    }) {
      this.contractItem = {
        id,
        state,
        productName,
        initiatorCount,
        productGroupName,
        productCategory,
        description,
        count,
        unitTypeName,
      };
      this.dialog = true;
      this.getInitiator();
    },
  },
};
</script>
<style lang="scss" scoped>
.mini-attribute-dotes {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
</style>
